import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const uploadImages = async (files) => {
  const urls = [];
  for (const f of files) {
    const fd = new FormData();
    fd.append("file", f);
    try {
      const { data } = await api.post("/upload", fd);
      if (data?.url) urls.push(data.url);
    } catch (e) {
      toast.error(`${f.name}: ${errMsg(e)}`);
    }
  }
  return urls;
};

export const DropZone = ({ onUrls, multiple = false, className = "", testid, children }) => {
  const input = useRef(null);
  const [over, setOver] = useState(false);
  const [busy, setBusy] = useState(false);
  const handle = async (list) => {
    const files = [...(list || [])].filter((f) => f.type.startsWith("image/"));
    if (!files.length) return;
    setBusy(true);
    const urls = await uploadImages(multiple ? files : files.slice(0, 1));
    setBusy(false);
    if (urls.length) onUrls(urls);
  };
  return (
    <div
      data-testid={testid}
      role="button"
      tabIndex={0}
      onClick={() => input.current?.click()}
      onKeyDown={(e) => e.key === "Enter" && input.current?.click()}
      onDragOver={(e) => { if (e.dataTransfer.types.includes("Files")) { e.preventDefault(); setOver(true); } }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { if (!e.dataTransfer.files?.length) return; e.preventDefault(); setOver(false); handle(e.dataTransfer.files); }}
      className={`relative cursor-pointer border border-dashed transition-colors ${over ? "border-white bg-white/10" : "border-[var(--line)] hover:border-[var(--muted)]"} ${className}`}
    >
      <input ref={input} type="file" accept="image/*" multiple={multiple} hidden onChange={(e) => { handle(e.target.files); e.target.value = ""; }} />
      {children || (
        <span className="flex flex-col items-center justify-center gap-2 h-full p-4 text-center font-mono text-[11px] uppercase tracking-[0.15em] text-[var(--muted)]">
          <UploadCloud className="w-5 h-5" />
          {busy ? "Uploading…" : multiple ? "Drop photos or click" : "Drop photo or click"}
        </span>
      )}
      {busy && children && <span className="absolute inset-0 grid place-items-center bg-black/70 font-mono text-[11px] uppercase tracking-[0.2em]">Uploading…</span>}
    </div>
  );
};
